import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';
import { Link } from 'react-router-dom';
import { Routes } from '../../navigation/routes';

const FooterContainer = styled(Flex)`
  flex-shrink: 0;
  align-items: baseline; 
  padding: 20px;
  background-color: #000000;
  justify-content: center;
`;

const FooterButtons = styled(Flex)`
  align-items: center;
  color: #FFFFFF;
  text-align: center;
  max-width: 1400px;
  width: 100%;
`;

const FooterTitle = styled(Link)`
  font-size: 1.1em;
  margin: 0px 15px;
  color: inherit;
  text-decoration: inherit;  
`;

const FooterSubTitle = styled(Link)`
  font-size: 0.8em;
  margin: 0px 15px;
  color: inherit;
  text-decoration: inherit;  
`;

const FooterButton = styled(Link)`
  font-size: 0.7em;
  margin: 0px 10px;
  cursor: pointer;
  color: inherit;
  text-decoration: inherit;  
`;

const VerticalDivider = styled.div`
    background-color: #d3d3d36b;
    height: 3em;
    width: 2px;
`;

interface FooterIProps {

}

interface FooterIState {

}

export default class Footer extends Component<FooterIProps, FooterIState>{

  render() {
    return <FooterContainer>
      <FooterButtons>
        <Flex flexDirection='column'>
          <FooterTitle to={Routes.Homepage}>
            All rights reserved
                    </FooterTitle>
          <FooterSubTitle to={Routes.Homepage}>
            ® 2020
                    </FooterSubTitle>
        </Flex>
        <VerticalDivider />
        <FooterButton to={Routes.TermsAndConditions}>Terms and Conditions</FooterButton>
        <FooterButton to={Routes.PrivacyPolicy}>Privacy Policy</FooterButton>
      </FooterButtons>
    </FooterContainer>
  }
}
